module.exports = __webpack_public_path__ + "static/media/pic29.64959ab6.jpg";